export default "Meta-analytische Übersicht zum Zusammenhang zwischen Selbstwirksamkeit bei Krebs und geringerer Belastung bzw. höherer Lebensqualität."